import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRightLong } from "react-icons/fa6";
import logo from "../../../Assets/logo_header.png";
import icon from "../../../Assets/icon_menu.png";
import file from '../../../Documents/file.pdf'
import * as S from "./styles";

export const MenuMobile = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [open, setOpen] = useState(false)
  const navigate = useNavigate();

  const buttons = [
    { label: "Home", link: "/" },
    {
      label: "Soluções",
      subItems: [
        { label: "Bindinntech", link: "/solucoes/bindinntech" },
        { label: "Bindtrack", link: "/solucoes/bindtrack" },
        { label: "Fisioteraplay", link: "/solucoes/fisioteraplay" },
        { label: "Atendevet", link: "/solucoes/atendevet" },
        { label: "Whatsign", link: "/solucoes/whatsign" },
      ],
    },
    { label: "Cases", link: "/cases" },
    { label: "Quem Somos", link: "/quem-somos" },
    {
      label: "Política da Empresa",
      subItems: [
        { label: "Código de Conduta e Ética", link: file },
        { label: "Canal de Denúncias", link: "/canalDenuncia" },
      ],
    },
    { label: "Contato", link: "/contato" },
  ];

  const handleClick = (index) => {
    navigate(buttons[index].link);
    setActiveIndex(index)
    setOpen(false)
  };

  useEffect(() => {
    if (activeIndex !== null) {
      const timer = setTimeout(() => {
        setActiveIndex(null);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [activeIndex]);

  return (
    <S.Wrapper>
      <S.Modal
        style={{ display: open ? 'flex' : 'none' }}
        onClick={() => setOpen(!open)}
      >
        {/* <S.ButtonBox >
          {buttons.map((btn, i) => (
            <S.BtnMenu
              active={activeIndex === i}
              key={i}
              onClick={() => handleClick(i)}
            >
              {btn.label}
            </S.BtnMenu>
          ))}
        </S.ButtonBox> */}
        <S.ButtonBox>
          {buttons.map((btn, i) => (
            <div key={i}
              style={{
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              {/* item principal */}
              <S.BtnMenu
                active={activeIndex === i}
                onClick={() => {
                  if (!btn.subItems) handleClick(i);
                }}
              >
                {btn.label}
              </S.BtnMenu>

              {/* subitens sempre visíveis, em lista vertical */}

              {btn.subItems && (
                <S.SubMenu>
                  {btn.subItems.map((sub, j) => (
                    sub.label === "Código de Conduta e Ética" ? (
                      <S.AMenu
                        key={`${i}-${j}`}
                        href={sub.link}
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {sub.label}
                      </S.AMenu>
                    ) : (
                      <S.BtnMenu
                        key={`${i}-${j}`}
                        onClick={() => {
                          navigate(sub.link);
                          setOpen(false);
                        }}
                      >
                        {sub.label}
                      </S.BtnMenu>
                    )
                  ))}
                </S.SubMenu>
              )}
            </div>
          ))}
        </S.ButtonBox>


      </S.Modal>
      <S.LogoMenu>
        <S.Logo onClick={() => navigate("/")}>
          <img src={logo} alt="Logo" />
        </S.Logo>


        <S.LogoMenuRight>
          <S.ActionBtn
            onClick={() => navigate("/contato")}
            className="ActionBtnTop"
          >
            Fale com um especialista
            <FaArrowRightLong size={24} />
          </S.ActionBtn>

          <S.MenuBtn onClick={() => setOpen(!open)}>
            <img src={icon} alt="" />
          </S.MenuBtn>
        </S.LogoMenuRight>
      </S.LogoMenu>


      <S.ActionBtn
        onClick={() => navigate("/contato")}
        className="ActionBtnBottom"
      >
        Fale com um especialista
        <FaArrowRightLong size={24} />
      </S.ActionBtn>
    </S.Wrapper>
  );
};
